var throttle = function (fn, threshhold, scope) {
  threshhold || (threshhold = 250);
  var last,
      deferTimer;
  return function () {
    var context = scope || this;

    var now = +new Date,
        args = arguments;
    if (last && now < last + threshhold) {
      // hold on to it
      clearTimeout(deferTimer);
      deferTimer = setTimeout(function () {
        last = now;
        fn.apply(context, args);
      }, threshhold);
    } else {
      last = now;
      fn.apply(context, args);
    }
  };
}
var desktopWidth = function() {
  return window.innerWidth > 1023;
}
var mainnav = document.querySelector('.mainnav');
var sectionStart = document.querySelector('.section--start');
var myScrollEvent = function(y) {
  if(desktopWidth()) {
    if (y > 100) {
        mainnav.classList.add('mainnav--active');
        sectionStart.classList.add('nav--active');
    } else {
        mainnav.classList.remove('mainnav--active');
        sectionStart.classList.remove('nav--active');
    }
  }
}
// Listen for resize events
window.addEventListener('scroll', throttle(function (event) {
    myScrollEvent(this.scrollY);
}, 500), false);
// Typewriter
var headline = document.getElementById('headline');
if(headline) {
  var typewriter = new Typewriter(headline, {
      loop: false,
      // delay: 150,
  });

  typewriter
    .pauseFor(100)
    .typeString('Die Zeit ist ')
    .pauseFor(1000)
    .typeString('<strong>jetzt</strong>.')
    .callFunction(function() {
      console.log('type done');
      sectionStart.classList.add('intro--done');
      window.setTimeout(function() {
        AOS.refreshHard();
      },1000)
    })
    .start();
  }
var $nav = document.querySelector('.mainnav');
var $navtrigger = document.getElementById('navtrigger');
$navtrigger.addEventListener('click', function() {
  console.log('nav trigger');
  $navtrigger.classList.toggle("close");
  $nav.classList.toggle("mainnav--active");
});

var hideNav = function() {
  console.log('scrollstart')
  $navtrigger.classList.remove("close");
  $nav.classList.remove("mainnav--active");
}


// Waypoints
var navitems = document.getElementsByClassName('mainnav__listitemlink');
var toggleNav = function(active) {
    Array.prototype.forEach.call(navitems, function(n) {
        n.classList.remove('mainnav__listitemlink--active');
        console.log('nav loop', n.getAttribute('data-nav'), active);
        if(n.getAttribute('data-nav') === active) {
            n.classList.add('mainnav__listitemlink--active');
        }
    });
}

var waypoints = document.getElementsByClassName('waypoint');
Array.prototype.forEach.call(waypoints, function(wp) {
    // Do stuff here
    console.log(wp.getAttribute('data-waypoint'));
    var waypointDown = new Waypoint({
        element: wp,
        offset: 200, 
        handler: function(direction) {
          console.log('Scrolled to waypoint!', wp.getAttribute('data-waypoint'), direction)
          if (direction === 'down') {
            toggleNav(wp.getAttribute('data-waypoint'));
          }  
        }
      })
      var waypointUp = new Waypoint({
        element: wp,
        offset: -100, 
        handler: function(direction) {
          console.log('Scrolled to waypoint!', wp.getAttribute('data-waypoint'), direction)
          if (direction === 'up') {
            toggleNav(wp.getAttribute('data-waypoint'));
          }
        }
      })
});

var scroll = new SmoothScroll('a[href*="#"]', {
  speed: 800,
	speedAsDuration: true
});

document.addEventListener('scrollStart', hideNav, false);

(function() {
  AOS.init({
      once: false,
      mirror: true,
  });
})();


